module.exports = __webpack_public_path__ + "img/pic_findbt.aa3b79fe.png";